var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvgFinanciamento(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "70px",
    viewBox: "0 0 72 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "serv_financiamento") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Assets_Board",
    transform: "translate(-1817.000000, -457.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 4.95
  }, /*#__PURE__*/React.createElement("g", {
    id: "serv_financiamento",
    transform: "translate(1820.000000, 460.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.8802816,51.9511032 C28.8802816,58.6436913 23.6002493,64.0521791 17.0992391,64.0521791 C10.598229,64.0521791 5.28516444,58.6436913 5.28516444,51.9511032 L5.28516444,44.0521791 C5.28516444,50.7447671 10.565229,55.4918447 17.0992391,55.4918447 C23.6002493,55.4918447 28.8802816,50.7058568 28.8802816,44.0521791 L28.8802816,51.9511032 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6212281,39.4677708 C25.6742252,42.6660859 21.6811785,44.6774537 17.0611715,44.6774537 C12.4411644,44.6774537 8.44811774,42.6331135 6.50111481,39.4677708 C5.7091136,38.1488779 5.24729817,36.6321995 5.24729817,34.9835835 C5.24729817,32.1479639 6.56722775,29.6090873 8.67923098,27.7626373 C10.8242342,25.8832151 13.7611341,24.7622447 17.0281392,24.7622447 C20.2951443,24.7622447 23.2322456,25.9161874 25.3772488,27.7626373 C27.5552523,29.576115 28.8752462,32.1479639 28.8752462,34.9835835 C28.8752462,36.6321995 28.4132293,38.1488779 27.6212281,39.4677708 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8802816,44.0509716 C28.8802816,49.7222108 23.6002493,53.7448418 17.0992391,53.7448418 C10.598229,53.7448418 5.28516444,49.6892385 5.28516444,44.0509716 L5.28516444,34.9835835 C5.28516444,29.3123443 10.565229,24.7292402 17.0992391,24.7292402 C20.3662442,24.7292402 23.3033455,25.8831829 25.4483488,27.7296328 C27.560352,29.5760828 28.8802816,32.1479639 28.8802816,34.9835835 L28.8802816,44.0509716 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66,31.4225166 C66,33.2359942 64.5479978,34.7196118 62.6999949,34.7855564 L56.2319131,34.7855564 C52.6679075,34.7855564 49.400991,32.1807593 49.1039905,28.6197486 C48.9059902,26.5424924 49.6979109,24.5971094 51.083913,23.2452443 C52.3049149,21.9922961 53.9879258,21.2669856 55.8359286,21.2669856 L62.6999949,21.2669856 C64.5479978,21.3329302 66,22.8165477 66,24.6300254 L66,31.4225166 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,23.0806242 L0,16.4861601 C0,7.51768893 5.4120166,1.2529401 13.8270295,0.197825872 C14.6850308,0.0659365936 15.5760241,0 16.5000256,0 L46.2000716,0 C47.0580729,0 47.8830742,0.0329320738 48.6750754,0.164821352 C57.1890884,1.153991 62.7000972,7.45174435 62.7000972,16.4861601 L62.7000972,21.2671868 L55.8360301,21.2671868 C53.9880273,21.2671868 52.3050166,21.9924974 51.0840147,23.2454455 C49.6980126,24.5973107 48.9060919,26.5426937 49.1040922,28.6199499 C49.4010927,32.1809606 52.668009,34.7857576 56.2320146,34.7857576 L62.7000972,34.7857576 L62.7000972,39.5667843 C62.7000972,49.4584804 56.1000869,56.0529445 46.2000716,56.0529445 L37.9500588,56.0529445",
    id: "Vector"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgFinanciamento);
export default __webpack_public_path__ + "static/media/svg_financiamento.3ec21b99cdf2d9111e4b89e5685421bb.svg";
export { ForwardRef as ReactComponent };